<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ (webhook === null) ? 'Add Webhook' : 'Update Webhook' }}</p>
      </header>
      <section class="modal-card-body">
        <div class="pb-lg">
          <!-- Error -->
          <b-message v-if="error !== null" type="is-danger">
            <span class="has-text-weight-bold">Error! </span>
            <span>{{ error }}</span>
          </b-message>
          <!-- Topic -->
          <b-field
            label="Topic"
            :type="('topic' in errors) ? 'is-danger' : ''"
            :message="('topic' in errors) ? errors['topic'][0] : ''"
            expanded>
            <b-select
              v-model="topic"
              placeholder="Select Topic"
              expanded>
              <option v-for="webhook in webhooksList" :key="webhook.action" :value="webhook.action">
                {{ webhook.label }}
              </option>
            </b-select>
          </b-field>
          <!-- Method & URL -->
          <div class="columns">
            <div class="column is-narrow">
              <b-field
                label="Method"
                :type="('target_method' in errors) ? 'is-danger' : ''"
                :message="('target_method' in errors) ? errors['target_method'][0] : ''"
                expanded>
                <b-select
                  v-model="targetMethod"
                  expanded>
                  <option value="post">POST</option>
                  <option value="put">PUT</option>
                  <option value="patch">PATCH</option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="URL"
                :type="('target_url' in errors) ? 'is-danger' : ''"
                :message="('target_url' in errors) ? errors['target_url'][0] : ''"
                expanded>
                  <b-input
                    autocomplete="off"
                    type="url"
                    v-model="targetUrl"
                  ></b-input>
              </b-field>
            </div>
          </div>
          <!-- Statsu -->
          <b-field
            label="Status"
            :type="('status' in errors) ? 'is-danger' : ''"
            :message="('status' in errors) ? errors['status'][0] : ''"
            expanded>
            <b-select
              v-model="status"
              expanded>
              <option value="enabled">Enabled</option>
              <option value="disabled">Disabled</option>
            </b-select>
          </b-field>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          native-type="submit"
          class="button is-primary"
          :loading="saving"
          :disabled="!ready || saving"
        >{{ webhookButtonText }}</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      saving: false,
      error: null,
      errors: [],
      isDirty: false,
      topic: null,
      targetMethod: null,
      targetUrl: null,
      status: 'enabled',
      webhookData: [
        { action: 'Brand Completed Onboarding', label: 'Brand Completed Onboarding', partner: 'retailer' },
        { action: 'Brand Location Created', label: 'Brand Location Created', partner: 'retailer' },
        { action: 'Brand Location Deleted', label: 'Brand Location Deleted', partner: 'retailer' },
        { action: 'Brand Location Updated', label: 'Brand Location Updated', partner: 'retailer' },
        { action: 'Connection Created', label: 'Connection Created', partner: 'any' },
        { action: 'Connection Established', label: 'Connection Established', partner: 'any' },
        { action: 'Credit Memo Created', label: 'Credit Memo Created', partner: 'retailer' },
        { action: 'Feed Request Approved', label: 'Feed Request Approved', partner: 'retailer' },
        { action: 'Feed Request Reviewed', label: 'Feed Request Reviewed', partner: 'retailer' },
        { action: 'Invoice Created', label: 'Invoice Created', partner: 'retailer' },
        { action: 'Variant Inventory Updated', label: 'Item Inventory Updated', partner: 'retailer' },
        { action: 'Permit Created', label: 'Offer Created', partner: 'retailer' },
        { action: 'Order Backorder Date Updated', label: 'Order Backorder Date Updated', partner: 'retailer' },
        { action: 'Order Backordered', label: 'Order Backordered', partner: 'retailer' },
        { action: 'Order Canceled', label: 'Order Canceled', partner: 'any' },
        { action: 'Order Closed', label: 'Order Closed', partner: 'retailer' },
        { action: 'Order Created', label: 'Order Created', partner: 'brand' },
        { action: 'Order Returned', label: 'Order Returned', partner: 'any' },
        { action: 'Order Ship To Address Updated', label: 'Order Ship To Address Updated', partner: 'brand' },
        { action: 'Cancel Request Created', label: 'Order Cancel Request Created', partner: 'brand' },
        { action: 'Cancel Request Approved', label: 'Order Cancel Request Approved', partner: 'retailer' },
        { action: 'Cancel Request Rejected', label: 'Order Cancel Request Rejected', partner: 'retailer' },
        { action: 'Cancel Request Expired', label: 'Order Cancel Request Expired', partner: 'retailer' },
        { action: 'Proposal Approved', label: 'Proposal Approved', partner: 'brand' },
        { action: 'Collaborator Added', label: 'Proposal Collaborator Added', partner: 'brand' },
        { action: 'Proposal Completed', label: 'Proposal Completed', partner: 'brand' },
        { action: 'Proposal Created', label: 'Proposal Created', partner: 'retailer' },
        { action: 'Proposal Declined', label: 'Proposal Declined', partner: 'brand' },
        { action: 'Owner Reassigned', label: 'Proposal Owner Reassigned', partner: 'brand' },
        { action: 'Proposal Pricing Approved', label: 'Proposal Pricing Approved', partner: 'brand' },
        { action: 'Proposal Product Approved', label: 'Proposal Product Approved', partner: 'brand' },
        { action: 'Proposal Product Rejected', label: 'Proposal Product Rejected', partner: 'brand' },
        { action: 'Proposal Proposed', label: 'Proposal Proposed', partner: 'retailer' },
        { action: 'Proposal Revised', label: 'Proposal Revised', partner: 'brand' },
        { action: 'Proposal Variant Added', label: 'Proposal Variant Added', partner: 'retailer' },
        { action: 'Proposal Variant Approved', label: 'Proposal Variant Approved', partner: 'brand' },
        { action: 'Proposal Variant Rejected', label: 'Proposal Variant Rejected', partner: 'brand' },
        { action: 'Proposal Variant Removed', label: 'Proposal Variant Removed', partner: 'brand' },
        { action: 'RMA Approved', label: 'RMA Approved', partner: 'any' },
        { action: 'RMA Completed', label: 'RMA Completed', partner: 'any' },
        { action: 'RMA Rejected', label: 'RMA Rejected', partner: 'any' },
        { action: 'RMA Return Approved', label: 'RMA Return Approved', partner: 'any' },
        { action: 'RMA Return Received', label: 'RMA Return Received', partner: 'any' },
        { action: 'RMA Return Rejected', label: 'RMA Return Rejected', partner: 'any' },
        { action: 'Shipment Closed', label: 'Shipment Closed', partner: 'retailer' },
        { action: 'Shipment Created', label: 'Shipment Created', partner: 'retailer' },
        { action: 'Shipment Updated', label: 'Shipment Updated', partner: 'retailer' },
        { action: 'Variant Created', label: 'Variant Created', partner: 'retailer' },
        { action: 'Description Attribute Updated', label: 'Variant Description Attribute Updated', partner: 'retailer' },
        { action: 'General Attribute Updated', label: 'Variant General Attribute Updated', partner: 'retailer' },
        { action: 'Identifiers Attribute Updated', label: 'Variant Identifier Attribute Updated', partner: 'retailer' },
        { action: 'Images Attribute Updated', label: 'Variant Image Attribute Updated', partner: 'retailer' },
        { action: 'Misc Attribute Updated', label: 'Variant Misc Attribute Updated', partner: 'retailer' },
        { action: 'Shipping Attribute Updated', label: 'Variant Shipping Attribute Updated', partner: 'retailer' },
        { action: 'Pricing Attribute Updated', label: 'Variant Pricing Attribute Updated', partner: 'retailer' }
      ]
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      let route = this.context.route + '/webhooks/'
      if (this.webhook !== null) {
        route += this.webhook.id + '/'
      }
      return route
    },
    method () {
      return (this.webhook === null) ? 'post' : 'patch'
    },
    ready () {
      return (
        this.topic &&
        this.targetMethod &&
        this.targetUrl &&
        this.status
      )
    },
    json () {
      return {
        status: this.status,
        action: {
          name: this.topic
        },
        target_method: this.targetMethod,
        target_url: this.targetUrl
      }
    },
    webhooksList () {
      return this.webhookData.filter(webhook => {
        if (this.context.isMerchant()) {
          return ['retailer', 'any'].includes(webhook.partner)
        } else if (this.context.isSupplier()) {
          return ['brand', 'any'].includes(webhook.partner)
        }
        return false
      })
    },
    webhookButtonText () {
      return (this.webhook === null) ? 'Add Webhook' : 'Update Webhook'
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http[this.method](this.endpoint, this.json).then(response => {
        this.saving = false
        this.$emit('updated')
        this.$buefy.toast.open({ type: 'is-success', message: 'Location saved!' })
        this.$parent.close()
      }).catch(error => {
        this.saving = false
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
        }
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      })
    }
  },
  mounted () {
    if (this.webhook !== null) {
      this.topic = this.webhook.action.name
      this.targetMethod = this.webhook.target_method
      this.targetUrl = this.webhook.target_url
      this.status = this.webhook.status
    }
  },
  props: ['webhook']
}
</script>
